var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tabs',{attrs:{"background-color":"transparent","center-active":"","right":"","grow":""}},_vm._l((_vm.packages),function(item){return _c('v-tab',{key:item.title,attrs:{"to":{ name: 'changelog', params: { package: item.route } },"active-class":"active","link":""}},[_vm._v(" "+_vm._s(item.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }